import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './locales/zh-CN'
import en from './locales/en-US'

console.log('实际加载的中文包：', zh) // 确保这里打印的是修改后的内容


Vue.use(VueI18n)

export default new VueI18n({
  legacy: true, // 必须启用兼容模式以支持 Vue2
  // locale: localStorage.getItem('lang') || 'zh',
  locale: 'zh',
  fallbackLocale: 'en',
  messages: {
    en: en,
    zh: zh
  }
})



// WEBPACK FOOTER //
// ./src/i18n/index.js